import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div className="relative z-10 min-h-screen flex items-center justify-center bg-gradient-to-b from-bg to-white px-4">
      <div className="max-w-2xl w-full text-center">
        <div className="mb-8">
          <div className="text-9xl font-black text-primary mb-4">404</div>
          <h1 className="text-4xl md:text-5xl font-black text-gray-800 mb-4">
            الصفحة غير موجودة
          </h1>
          <p className="text-xl text-gray-600 mb-8">
            عذراً، الصفحة التي تبحث عنها غير موجودة أو تم نقلها.
          </p>
        </div>

        <div className="bg-white rounded-3xl shadow-custom-lg p-8 mb-8">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">ماذا تريد أن تفعل؟</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Link
              to="/"
              className="bg-primary text-white px-6 py-4 rounded-xl font-bold hover:bg-primary-dark transition-all duration-300 flex items-center justify-center gap-2"
            >
              <i className="fas fa-home"></i>
              العودة للرئيسية
            </Link>
            <Link
              to="/courses"
              className="bg-secondary text-white px-6 py-4 rounded-xl font-bold hover:opacity-90 transition-all duration-300 flex items-center justify-center gap-2"
            >
              <i className="fas fa-book"></i>
              تصفح الكتب
            </Link>
            <Link
              to="/about"
              className="bg-accent text-white px-6 py-4 rounded-xl font-bold hover:opacity-90 transition-all duration-300 flex items-center justify-center gap-2"
            >
              <i className="fas fa-info-circle"></i>
              عن المنصة
            </Link>
            <Link
              to="/contact"
              className="bg-gray-200 text-gray-700 px-6 py-4 rounded-xl font-bold hover:bg-gray-300 transition-all duration-300 flex items-center justify-center gap-2"
            >
              <i className="fas fa-envelope"></i>
              تواصل معنا
            </Link>
          </div>
        </div>

        <div className="bg-gradient-to-r from-primary to-secondary text-white rounded-2xl p-6">
          <p className="text-sm">
            إذا كنت تعتقد أن هذا خطأ، يرجى التواصل مع فريق الدعم
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
